export const state = {
  destinations: [],
  prospectiveDestinations: [],
  allDestinations: [],
  destinationsById: [],
};
